const arrayRandPick = (arr: []) => arr[Math.floor(Math.random() * arr.length)];

export default arrayRandPick;
